function importAll(r) {
    return r.keys().map(r);
  }
  
  const UAE_L = importAll(require.context('../assets/photos/UAE_L', false, /\.(png|jpe?g|svg)$/));

  export default UAE_L;